import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
const locations = ['Montevideo', 'Punta del Este', 'Piriápolis', 'San José', 'Colonia'];
export function Locations() {
  return <section className="py-24 bg-ivory" data-id="element-102">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-103">
        <div className="text-center mb-12" data-id="element-104">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-4xl text-charcoal mb-8" data-id="element-105">
            Encontranos cerca tuyo
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex flex-wrap justify-center gap-3 md:gap-4 mb-8" data-id="element-106">
            {locations.map((loc, i) => <div key={i} className="bg-white px-5 py-2.5 rounded-full shadow-sm border border-rosegold/10 flex items-center gap-2" data-id="element-107">
                <MapPin size={16} className="text-rosegold" data-id="element-108" />
                <span className="font-medium text-charcoal/80 text-sm md:text-base" data-id="element-109">
                  {loc}
                </span>
              </div>)}
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-charcoal/60 font-medium" data-id="element-110">
            Sede Central: Buxareo 1185, Montevideo
          </motion.p>
        </div>

        {/* Map Placeholder */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="w-full h-[400px] bg-gray-200 rounded-2xl overflow-hidden shadow-inner relative" data-id="element-111">
          {/* Simulated Map Background */}
          <div className="absolute inset-0 bg-[#e5e3df] opacity-50" data-id="element-112"></div>
          <div className="absolute inset-0 flex items-center justify-center flex-col" data-id="element-113">
            <MapPin size={48} className="text-rosegold mb-4 drop-shadow-md" data-id="element-114" />
            <span className="text-charcoal/50 font-medium text-lg" data-id="element-115">
              Mapa Interactivo
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}